import { doc, setDoc, getDoc, deleteDoc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export async function saveUserData(uid, appState) {
  if (!db) return;
  await setDoc(
    doc(db, 'users', uid),
    { appState, updatedAt: Date.now() },
    { merge: true }
  );
}

export async function loadUserData(uid) {
  if (!db) return null;
  const snap = await getDoc(doc(db, 'users', uid));
  if (!snap.exists()) return null;
  return snap.data();
}

export async function deleteUserData(uid) {
  if (!db) return;
  await deleteDoc(doc(db, 'users', uid));
}

export function subscribeToUserData(uid, callback) {
  if (!db) return () => {};
  return onSnapshot(doc(db, 'users', uid), (snap) => {
    if (snap.exists()) callback(snap.data());
  });
}

export async function updateUserPro(uid, isPro) {
  if (!db) return;
  await updateDoc(doc(db, 'users', uid), { isPro });
}
